export default "__VITE_ASSET__BxIqHe0I__"